export default class CatalogosFactory {
  //Opciones personas morales

  public static getTipoSolicitanteOptions(): any {
    return [
      { value: { id: '1', nombre: 'Persona moral (Empresa o Institución)' }, text: 'Persona moral (Empresa o Institución)' },
      { value: { id: '2', nombre: 'Persona física con actividad empresarial' }, text: 'Persona física con actividad empresarial' },
    ];
  }

  public static getSectorOptions(): any {
    return [
      { value: { id: '1', nombre: 'Privada' }, text: 'Privada' },
      { value: { id: '2', nombre: 'Público' }, text: 'Público' },
      { value: { id: '3', nombre: 'Social' }, text: 'Social' },
    ];
  }

  public static getTipoInstitucionEmpresaOptions(): any {
    return [
      { value: { id: '5', nombre: 'Centro de Investigación' }, text: 'Centro de Investigación' },
      { value: { id: '6', nombre: 'Empresa' }, text: 'Empresa' },
      { value: { id: '4', nombre: 'Institución Privada no lucrativa' }, text: 'Institución Privada no lucrativa' },
      { value: { id: '7', nombre: 'Institución de Educación' }, text: 'Institución de Educación' },
      { value: { id: '8', nombre: 'Persona Fisica con Actividad Empresarial' }, text: 'Persona Fisica con Actividad Empresarial' },
    ];
  }

  public static getFiguraJuridicaOptions(): any {
    return [
      { value: { id: '33', nombre: 'Asociación Agrícola' }, text: 'Asociación Agrícola' },
      { value: { id: '1', nombre: 'Asociación civil' }, text: 'Asociación civil' },
      { value: { id: '11', nombre: 'Asociación en participación' }, text: 'Asociación en participación' },
      { value: { id: '31', nombre: 'Asociación rural de interés colectivo' }, text: 'Asociación rural de interés colectivo' },
      { value: { id: '6', nombre: 'Comandita por acciones' }, text: 'Comandita por acciones' },
      { value: { id: '7', nombre: 'Comandita simple' }, text: 'Comandita simple' },
      {
        value: { id: '34', nombre: 'Sociedad Anónima Bursátil de Capital Variable' },
        text: 'Sociedad Anónima Bursátil de Capital Variable',
      },
      { value: { id: '2', nombre: 'Sociedad anónima' }, text: 'Sociedad anónima' },
      { value: { id: '29', nombre: 'Sociedad anónima de capital variable' }, text: 'Sociedad anónima de capital variable' },
      { value: { id: '12', nombre: 'Sociedad anónima promotora de inversión' }, text: 'Sociedad anónima promotora de inversión' },
      {
        value: { id: '13', nombre: 'Sociedad anónima promotora de inversión de capital variable' },
        text: 'Sociedad anónima promotora de inversión de capital variable',
      },
      {
        value: { id: '14', nombre: 'Sociedad anónima promotora de inversión de responsabilidad limitada' },
        text: 'Sociedad anónima promotora de inversión de responsabilidad limitada',
      },
      {
        value: { id: '15', nombre: 'Sociedad anónima promotora de inversión de responsabilidad limitada de capital variable' },
        text: 'Sociedad anónima promotora de inversión de responsabilidad limitada de capital variable',
      },
      { value: { id: '3', nombre: 'Sociedad civil' }, text: 'Sociedad civil' },
      { value: { id: '4', nombre: 'Sociedad cooperativa' }, text: 'Sociedad cooperativa' },
      {
        value: { id: '16', nombre: 'Sociedad cooperativa de responsabilidad limitada' },
        text: 'Sociedad cooperativa de responsabilidad limitada',
      },
      {
        value: { id: '17', nombre: 'Sociedad cooperativa de responsabilidad limitada de capital variable' },
        text: 'Sociedad cooperativa de responsabilidad limitada de capital variable',
      },
      { value: { id: '18', nombre: 'Sociedad cooperativa limitada' }, text: 'Sociedad cooperativa limitada' },
      { value: { id: '19', nombre: 'Sociedad cooperativa suplementada' }, text: 'Sociedad cooperativa suplementada' },
      { value: { id: '20', nombre: 'Sociedad de producción rural' }, text: 'Sociedad de producción rural' },
      {
        value: { id: '21', nombre: 'Sociedad de producción rural de responsabilidad ilimitada' },
        text: 'Sociedad de producción rural de responsabilidad ilimitada',
      },
      {
        value: { id: '22', nombre: 'Sociedad de producción rural de responsabilidad limitada' },
        text: 'Sociedad de producción rural de responsabilidad limitada',
      },
      {
        value: { id: '23', nombre: 'Sociedad de producción rural de responsabilidad limitada de capital variable' },
        text: 'Sociedad de producción rural de responsabilidad limitada de capital variable',
      },
      { value: { id: '5', nombre: 'Sociedad de responsabilidad limitada' }, text: 'Sociedad de responsabilidad limitada' },
      {
        value: { id: '24', nombre: 'Sociedad de responsabilidad limitada de capital variable' },
        text: 'Sociedad de responsabilidad limitada de capital variable',
      },
      {
        value: { id: '25', nombre: 'Sociedad de responsabilidad limitada de interés público' },
        text: 'Sociedad de responsabilidad limitada de interés público',
      },
      {
        value: { id: '26', nombre: 'Sociedad de responsabilidad limitada microindustrial' },
        text: 'Sociedad de responsabilidad limitada microindustrial',
      },
      {
        value: { id: '32', nombre: 'Sociedad de responsabilidad limitada microindustrial artesanal' },
        text: 'Sociedad de responsabilidad limitada microindustrial artesanal',
      },
      { value: { id: '27', nombre: 'Sociedad de solidaridad social' }, text: 'Sociedad de solidaridad social' },
      { value: { id: '8', nombre: 'Sociedad en nombre colectivo' }, text: 'Sociedad en nombre colectivo' },
      { value: { id: '28', nombre: 'Sociedad por acciones simplificadas' }, text: 'Sociedad por acciones simplificadas' },
      {
        value: { id: '30', nombre: 'Sociedad por acciones simplificadas de capital variable' },
        text: 'Sociedad por acciones simplificadas de capital variable',
      },
      { value: { id: '9', nombre: 'Sociedades de capital variable' }, text: 'Sociedades de capital variable' },
      { value: { id: '10', nombre: 'Sociedades mercantiles con fines de lucro' }, text: 'Sociedades mercantiles con fines de lucro' },
    ];
  }

  public static getTamanioEmpresaOptions(): any {
    return [
      { value: { id: '4', nombre: 'Grande' }, text: 'Grande' },
      { value: { id: '3', nombre: 'Mediana' }, text: 'Mediana' },
      { value: { id: '1', nombre: 'Microempresa' }, text: 'Microempresa' },
      { value: { id: '5', nombre: 'Nano' }, text: 'Nano' },
      { value: { id: '2', nombre: 'Pequeña' }, text: 'Pequeña' },
    ];
  }

  public static getNivelOptions(): any {
    return [
      { value: { id: '2', nombre: 'Estatal' }, text: 'Estatal' },
      { value: { id: '1', nombre: 'Federal' }, text: 'Federal' },
      { value: { id: '3', nombre: 'Municipal' }, text: 'Municipal' },
    ];
  }

  public static getTipoInstitucionEntidadOptions(): any {
    return [
      { value: { id: '1', nombre: 'Centro de Investigación CONACYT' }, text: 'Centro de Investigación CONACYT' },
      { value: { id: '3', nombre: 'Centros de Investigación' }, text: 'Centros de Investigación' },
      { value: { id: '4', nombre: 'Institución de Educación' }, text: 'Institución de Educación' },
      { value: { id: '5', nombre: 'Sector Público' }, text: 'Sector Público' },
    ];
  }

  public static getClasificacionOptions(): any {
    return [
      { value: { id: '4', nombre: 'Institución de Educación Básica' }, text: 'Institución de Educación Básica' },
      { value: { id: '5', nombre: 'Institución de Educación Media' }, text: 'Institución de Educación Media' },
      { value: { id: '6', nombre: 'Institución de Educación Superior' }, text: 'Institución de Educación Superior' },
      { value: { id: '7', nombre: 'Poder Ejecutivo' }, text: 'Poder Ejecutivo' },
      { value: { id: '8', nombre: 'Poder Legislativo' }, text: 'Poder Legislativo' },
      { value: { id: '9', nombre: 'Poder Judicial' }, text: 'Poder Judicial' },
    ];
  }

  public static getGrupoSocialOptions(): any {
    return [
      {
        value: { id: '8', nombre: 'Pueblos y comunidades indígenas, afromexicanas equiparables' },
        text: 'Pueblos y comunidades indígenas, afromexicanas equiparables',
      },
    ];
  }

  public static getActividadPrepnderanteOptions(): any {
    return [
      { value: { id: '1', nombre: 'Humanista' }, text: 'Humanista' },
      { value: { id: '2', nombre: 'Científico' }, text: 'Científico' },
      { value: { id: '3', nombre: 'Tecnólogo' }, text: 'Tecnólogo' },
      { value: { id: '4', nombre: 'Innovador' }, text: 'Innovador' },
      { value: { id: '5', nombre: 'Varios' }, text: 'Varios' },
    ];
  }

  public static getCatTipoDocumentoCreacion(): any {
    return [
      { value: { id: '1', nombre: 'Acta constitutiva' }, text: 'Acta constitutiva' },
      { value: { id: '2', nombre: 'Acuerdo' }, text: 'Acuerdo' },
      { value: { id: '3', nombre: 'Contrato de fideicomiso' }, text: 'Contrato de fideicomiso' },
      { value: { id: '4', nombre: 'Decreto' }, text: 'Decreto' },
      {
        value: { id: '5', nombre: 'Inscripción del acto constitutiv de las sociedad por acciones simplificadas' },
        text: 'Inscripción del acto constitutiv de las sociedad por acciones simplificadas',
      },
      { value: { id: '6', nombre: 'Ley' }, text: 'Ley' },
      { value: { id: '7', nombre: 'Póliza' }, text: 'Póliza' },
      { value: { id: '8', nombre: 'Reglamento' }, text: 'Reglamento' },
      { value: { id: '9', nombre: 'Declarar Asamblea' }, text: 'Declarar Asamblea' },
      { value: { id: '10', nombre: 'Otro documento constitutivo' }, text: 'Otro documento constitutivo' },
    ];
  }

  public static getCatTipoSectorPrivada(): any {
    return [{ value: { id: '5', nombre: 'Poder notarial' }, text: 'Poder notarial' }];
  }

  public static getCatTipoSectorPublico(): any {
    return [
      { value: { id: '1', nombre: 'Decreto' }, text: 'Decreto' },
      { value: { id: '2', nombre: 'Ley' }, text: 'Ley' },
      { value: { id: '3', nombre: 'Nombramiento' }, text: 'Nombramiento' },
      { value: { id: '4', nombre: 'Oficio' }, text: 'Oficio' },
      { value: { id: '5', nombre: 'Poder notarial' }, text: 'Poder notarial' },
      { value: { id: '6', nombre: 'Reglamento' }, text: 'Reglamento' },
      { value: { id: '7', nombre: 'Otro' }, text: 'Otro' },
    ];
  }

  public static getCatTipoSectorSocial(): any {
    return [
      { value: { id: '1', nombre: 'Decreto' }, text: 'Decreto' },
      { value: { id: '2', nombre: 'Ley' }, text: 'Ley' },
      { value: { id: '3', nombre: 'Nombramiento' }, text: 'Nombramiento' },
      { value: { id: '4', nombre: 'Oficio' }, text: 'Oficio' },
      { value: { id: '5', nombre: 'Poder notarial' }, text: 'Poder notarial' },
      { value: { id: '6', nombre: 'Reglamento' }, text: 'Reglamento' },
      { value: { id: '7', nombre: 'Otro' }, text: 'Otro' },
    ];
  }

  public static getCatTipoPoder(): any {
    return [
      { value: { id: '1', nombre: 'Poder general' }, text: 'Poder general' },
      { value: { id: '2', nombre: 'Poder especial' }, text: 'Poder especial' },
      { value: { id: '3', nombre: 'Otro' }, text: 'Otro' },
    ];
  }

  public static getCatEstatusRevisor(): any {
    return [
      { value: { id: '0', nombre: 'Todos' }, text: 'Todos' },
      { value: { id: '2', nombre: 'Enviado a Revisión' }, text: 'Enviado a Revisión' },
      { value: { id: '4', nombre: 'Revisado con Observaciones' }, text: 'Revisado con Observaciones' },
      { value: { id: '6', nombre: 'Revisado sin Observaciones' }, text: 'Revisado sin Observaciones' },
    ];
  }

  public static getCatEstatusAdmin(): any {
    return [
      { value: { id: '0', nombre: 'Todos' }, text: 'Todos' },
      { value: { id: '1', nombre: 'Captura' }, text: 'Captura' },
      { value: { id: '2', nombre: 'Enviado a Revisión' }, text: 'Enviado a Revisión' },
      { value: { id: '4', nombre: 'Revisado con Observaciones' }, text: 'Revisado con Observaciones' },
      { value: { id: '6', nombre: 'Revisado sin Observaciones' }, text: 'Revisado sin Observaciones' },
    ];
  }
}
